// Copied from platform-app components/pos/layout/previewPalette.ts on 2026-10-14 for Super Admin → POS Defaults — keep in step with the original.
// Mirrors AGENTIC_POS src/index.css (dark) and src/theme/tokens.ts (light) — keep in sync.
// Surface colours for the layout editor's POS previews only. Tiles themselves always
// come from resolveButtonLook (config/buttonTheme.ts).

export type PreviewTheme = 'light' | 'dark';

export interface PreviewPalette {
  railBg: string;
  railBor: string;
  moreBg: string;
  moreTx: string;
  badgeBg: string;
  badgeTx: string;
  head: string;
  headBor: string;
  input: string;
  inputTx: string;
  body: string;
  tx: string;
  mu: string;
  /** Keypad tab: the till's keypad surface + key colours. */
  kpBg: string;
  key: string;
  keyBor: string;
  keyTx: string;
  keyMu: string;
  addBg: string;
  addTx: string;
  destr: string;
}

export const PREVIEW_PALETTE: Record<PreviewTheme, PreviewPalette> = {
  light: {
    railBg: '#fafafa', railBor: '#e4e4e7', moreBg: '#18181b', moreTx: '#ffffff',
    badgeBg: '#18181b', badgeTx: '#ffffff', head: '#ffffff', headBor: '#e4e4e7',
    input: '#f4f4f5', inputTx: '#71717a', body: '#ffffff', tx: '#18181b', mu: '#71717a',
    kpBg: '#f4f4f5', key: '#ffffff', keyBor: '#e4e4e7', keyTx: '#18181b', keyMu: '#71717a',
    addBg: '#18181b', addTx: '#ffffff', destr: '#b91c1c',
  },
  dark: {
    railBg: '#0f0f0f', railBor: '#1e1e22', moreBg: '#2a2a30', moreTx: '#ffffff',
    badgeBg: '#ffffff', badgeTx: '#0f0f0f', head: '#161618', headBor: '#2a2a30',
    input: '#2a2a30', inputTx: '#9ca3af', body: '#161618', tx: '#f4f4f5', mu: '#9ca3af',
    kpBg: '#161618', key: '#1e1e22', keyBor: '#2a2a30', keyTx: '#ffffff', keyMu: '#9ca3af',
    addBg: '#ffffff', addTx: '#0f0f0f', destr: '#f87171',
  },
};
